module.exports = __webpack_public_path__ + "media/svg-new/lupax-c5886551.svg";